export default __webpack_public_path__ + "static/media/family4.300911a5.jpg";